import withAPIAction from 'helpers/withAPIAction'
import {
  PermissionListReq,
  CreatePermissionReq,
  UpdatePermissionReq,
  DeletePermissionReq,
  PermissionDetailReq,
} from './types'
import {
  getPermissionListAction,
  createPermissionAction,
  updatePermissionAction,
  deletePermissionAction,
  getPermissionDetailAction,
  getAllPermissionListAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'

export const permissionListAPI = (data: PermissionListReq, token: string, xmid: any) => {
  return withAPIAction<PermissionListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.permissionList}`,
    data,
    token,
    xmid,
    // hideOath: true,
  })(getPermissionListAction)
}

export const allPermissionListAPI = (data: PermissionListReq, token: string, xmid: any) => {
  return withAPIAction<PermissionListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.permissionList}`,
    data,
    token,
    xmid,
    // hideOath: true,
  })(getAllPermissionListAction)
}

export const createPermissionAPI = (data: CreatePermissionReq, token: string, xmid: string) => {
  return withAPIAction<CreatePermissionReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.createPermission,
    data,
    token,
    xmid,
  })(createPermissionAction)
}

export const updatePermissionAPI = (data: UpdatePermissionReq, token: string, xmid: string) => {
  const endPoint = APIPath.updatePermission.replace(':id', data.id.toString())
  return withAPIAction<UpdatePermissionReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(updatePermissionAction)
}

export const deletePermissionAPI = (data: DeletePermissionReq, token: string, xmid: string) => {
  const endPoint = APIPath.deletePermission.replace(':id', data.id.toString())
  return withAPIAction<DeletePermissionReq>({
    method: 'DELETE',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(deletePermissionAction)
}

export const getPermissionDetailAPI = (data: PermissionDetailReq, token: string, xmid: string) => {
  const endPoint = APIPath.getPermissionByID.replace(':id', data.id.toString())
  return withAPIAction<PermissionDetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(getPermissionDetailAction)
}
